module.exports = {"tasks":[{"id":1,"petName":"James","petOwner":"Alexandre Mouton-Brady","date":"2017-11-17","problem":"This Cane Corso is too cute to be true"},{"id":2,"petName":"Samba","petOwner":"Alexandre Mouton-Brady","date":"2017-10-16","problem":"This european cat got her craws stuck inside a chicken bone"},{"id":3,"petName":"Medor","petOwner":"Paul Henri","date":"2017-10-10","problem":"This Golden Retriever broke his leg while chasing rabits"},{"id":4,"petName":"Tuta","petOwner":"Gary Coldgris","date":"2017-09-14","problem":"This turtle has been hibernated for two months longer than she should"}]}


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 34
// module chunks = 0